module.exports = __webpack_public_path__ + "img/target001-old.67c1e3ae.png";